const messages = {
  title: "Länderauswahl",
  dismissAria: "Hinweis zur Länderauswahl schließen",
  flagAlt: "Flagge {code}",
  currentTenant:
    "Sie befinden sich derzeit auf Bridgestone Plus {name} ({code}).",
  visitingFrom: "Offenbar rufen Sie die Seite aus {name} auf.",
  suggestPlatform:
    "Möchten Sie stattdessen auf der {name}-Plattform fortfahren?",
  lookingFor:
    "Suchen Sie {name} ({code})? Sie können mit einem Klick wechseln.",
  switchTo: "Wechseln zu {code}",
};

export default {
  messages,
};
